import { inject, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { SystemDateFormatService } from '@exl-ng/mulo-core';
import { DateUtils } from '../utils/date.utils';

@Pipe({
    name: 'espdateformat',
    standalone: true,
})
export class EspDateFormatPipe implements PipeTransform {
    sysDateFormatSvc = inject(SystemDateFormatService);

    transform(
        date: string,
        outputFormat = this.sysDateFormatSvc.getSystemDateFormat(),
    ): string {
        let parseFormat = 'YYYYMMDD';
        if (date?.length === 4) {
            parseFormat = 'YYYY';
            const match = outputFormat.match(/(y|Y)+/);
            outputFormat = match && match.length > 0 ? match[0] : null;
        } else if (date?.length === 6) {
            parseFormat = 'YYYYMM';
            outputFormat = outputFormat.replace(
                /(^(d|D)+[^mMyY])|([^mMyYdD](d|D)+)/,
                '',
            );
        }
        return !!date
            ? DateUtils.getFullMomentDateAsString(
                  moment(date, parseFormat),
                  outputFormat,
              )
            : '';
    }
}
